export const filterValidStrings = (items?: string[] | null): string[] =>
  items?.filter((item): item is string => Boolean(item.trim())) ?? [];

/** BA / admin edit use `phoneNumbers`; legacy reports use `phoneNumber`. */
export const resolveMerchantPhoneDisplay = (
  merchantDetails:
    | {
        phoneNumber?: string | null;
        phoneNumbers?: string[] | null;
      }
    | null
    | undefined,
): { text: string | null; copy: string } => {
  const fromArray = filterValidStrings(merchantDetails?.phoneNumbers);

  if (fromArray.length > 0) {
    const joined = fromArray.join(', ');

    return { text: joined, copy: joined };
  }

  const single = merchantDetails?.phoneNumber?.trim();

  if (single) {
    return { text: single, copy: single };
  }

  return { text: null, copy: '' };
};

/** BA / admin edit use `emailAddresses`; legacy reports use `email`. */
export const resolveMerchantEmailDisplay = (
  merchantDetails:
    | {
        email?: string | null;
        emailAddresses?: string[] | null;
      }
    | null
    | undefined,
): { text: string | null; copy: string } => {
  const fromArray = filterValidStrings(merchantDetails?.emailAddresses);

  if (fromArray.length > 0) {
    const joined = fromArray.join(', ');

    return { text: joined, copy: joined };
  }

  const single = merchantDetails?.email?.trim();

  if (single) {
    return { text: single, copy: single };
  }

  return { text: null, copy: '' };
};

/** BA / admin edit use `physicalAddresses`; legacy reports use `address` or `physicalAddress`. */
export const resolveMerchantAddressDisplay = (
  merchantDetails:
    | {
        address?: string | null;
        physicalAddresses?: string[] | null;
        physicalAddress?: string | null;
      }
    | null
    | undefined,
): { text: string | null; copy: string } => {
  const single = merchantDetails?.address?.trim();

  if (single) {
    return { text: single, copy: single };
  }

  const fromArray = filterValidStrings(merchantDetails?.physicalAddresses);

  if (fromArray.length > 0) {
    const joined = fromArray.join(', ');

    return { text: joined, copy: joined };
  }

  const legacy = merchantDetails?.physicalAddress?.trim();

  if (legacy) {
    return { text: legacy, copy: legacy };
  }

  return { text: null, copy: '' };
};
